<template>
  <section>
    <div class="portfolio-wrap">
      <img :src="item.src" class="img-fluid" alt="" />

      <div class="portfolio-links">
        <a @click="showImg()"><i class="bx bx-plus"></i></a>
        <a title="More Details" @click="showDetails"
          ><i class="bx bx-link"></i
        ></a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PortfolioItem",
  props: ["item"],
  methods: {
    showImg() {
      this.$emit("lightbox", this.item.id);
    },
    showDetails() {
      this.$emit("details", this.item);
    }
  }
};
</script>
